import { render, staticRenderFns } from "./CosmoKillerR2.vue?vue&type=template&id=6ff22a08&scoped=true"
import script from "./CosmoKillerR2.vue?vue&type=script&lang=ts"
export * from "./CosmoKillerR2.vue?vue&type=script&lang=ts"
import style0 from "./CosmoKillerR2.vue?vue&type=style&index=0&id=6ff22a08&prod&lang=scss&scoped=true"
import style1 from "./CosmoKillerR2.vue?vue&type=style&index=1&id=6ff22a08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff22a08",
  null
  
)

export default component.exports